import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import HomePage from './components/HomePage';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Signup from './components/Signup';
import WorkflowBuilder from './components/WorkflowBuilder';
import ServicesPage from './components/ServicesPage';
import PricingPage from './components/PricingPage';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import AccountPage from './components/AccountPage';
import DeployModule from './components/DeployModule';
import AdminPage from './components/AdminPage';
import AdminSettings from './components/AdminSettings';
import AdminUsers from './components/AdminUsers';
import AdminAnalytics from './components/AdminAnalytics';
import AdminSecurity from './components/AdminSecurity';
import AIAgentConfig from './components/AIAgentConfig';
import InsideAIAgentConfig from './components/InsideAIAgentConfig';
import InsideWorkflowDetails from './components/InsideWorkflowDetails';
import LogsInsights from './components/LogsInsights';
import UserDashboard from './components/UserDashboard';
import ServiceDetail from './components/ServiceDetail';
import TestPage from './components/TestPage';
import AnnouncementPage from './components/AnnouncementPage';
// Service Category Pages
import RetailDiningService from './components/RetailDiningService';
import MediaSynthesisService from './components/MediaSynthesisService';
import CoreIntelligenceService from './components/CoreIntelligenceService';
import AutonomousSupportService from './components/AutonomousSupportService';
import GrowthEnginesService from './components/GrowthEnginesService';
import WorkflowsPage from './components/WorkflowsPage';
import InfrastructurePage from './components/InfrastructurePage';


function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <Router>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/user-dashboard" element={<UserDashboard />} />
              <Route path="/workflow-builder" element={<WorkflowBuilder />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:serviceId" element={<ServiceDetail />} />
              {/* Service Category Routes */}
              <Route path="/services/retail-dining" element={<RetailDiningService />} />
              <Route path="/services/media-synthesis" element={<MediaSynthesisService />} />
              <Route path="/services/core-intelligence" element={<CoreIntelligenceService />} />
              <Route path="/services/autonomous-support" element={<AutonomousSupportService />} />
              <Route path="/services/growth-engines" element={<GrowthEnginesService />} />
              <Route path="/deploy-module" element={<DeployModule />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/announcement" element={<AnnouncementPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/analytics" element={<AdminAnalytics />} />
              <Route path="/admin/security" element={<AdminSecurity />} />
              <Route path="/ai-agents" element={<AIAgentConfig />} />
              <Route path="/ai-agents/:agentId" element={<InsideAIAgentConfig />} />
              <Route path="/workflows/:workflowId" element={<InsideWorkflowDetails />} />
              <Route path="/workflows" element={<WorkflowsPage />} />
              <Route path="/infrastructure" element={<InfrastructurePage />} />
              <Route path="/logs" element={<LogsInsights />} />
              {/* Test routes */}
              <Route path="/test" element={<TestPage />} />
              <Route path="/test-service" element={<ServiceDetail />} />
            </Routes>
          </Router>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
